import ApiService from "@/core/services/api.service";
// action types
export const PAGINATION_GALLERY_DATA = "paginationGalleryData";
export const LIST_GALLERY_DATA = "listGalleryData";
export const GET_GALLERY_DATA = "getGalleryData";
export const GET_GALLERY_PANO_DATA = "getGalleryPanoData";
export const POST_GALLERY_DATA = "postGalleryPanoData";
export const POST_GALLERY_PANO_DATA = "postGalleryData";
export const PUT_GALLERY_DATA = "putGalleryData";
export const PUT_GALLERY_PANO_DATA = "putGalleryPanoData";
export const PUT_GALLERY_STATUS_DATA = "putGalleryStatusData";
export const DELETE_GALLERY_DATA = "deleteGalleryData";
// mutation types
export const SET_PAGINATION = "setPagination";
export const SET_IS_CLEAR_PAGINATION = "setIsClearPagination";
export const CLEAR_PAGINATION = "clearPagination";

export default {
  state: {
    path: "gallery",
    isClearPagination: true,
    pagination: {
      page: 1,
      perPage: 25,
      orderBy: "id",
      isDesc: true,
      sortDirection: "asc",
      filter: ""
    }
  },
  getters: {},
  actions: {
    [PAGINATION_GALLERY_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/pagination`, {
        params: payload.params
      });
    },
    [LIST_GALLERY_DATA](context) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}`);
    },
    [GET_GALLERY_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/${payload.id}`);
    },
    [GET_GALLERY_PANO_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/panorama/${payload.id}`);
    },
    [POST_GALLERY_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.post(`${context.state.path}`, payload.data);
    },
    [POST_GALLERY_PANO_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.post(`${context.state.path}/panorama`, payload.data);
    },
    [PUT_GALLERY_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/panorama/${payload.id}`,
        payload.data
      );
    },
    [PUT_GALLERY_PANO_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/panorama/${payload.id}`,
        payload.data
      );
    },
    [PUT_GALLERY_STATUS_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/status/${payload.id}`,
        payload.data
      );
    },
    [DELETE_GALLERY_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.delete(`${context.state.path}/${payload.id}`);
    }
  },
  mutations: {
    [SET_PAGINATION](state, payload) {
      state.pagination = payload.pagination;
    },
    [SET_IS_CLEAR_PAGINATION](state, payload) {
      state.isClearPagination = payload.isClearPagination;
    },
    [CLEAR_PAGINATION](state) {
      state.pagination = {
        page: 1,
        perPage: 25,
        orderBy: "id",
        isDesc: true,
        sortDirection: "asc",
        filter: ""
      };
    }
  }
};
